import styled from 'styled-components';

export const Container = styled.div`
  .bg-light {
    background-color: #f0f1f2 !important;
  }

  li {
    color: #495057;
    background-color: #f0f1f2 !important;
  }

  ul {
    background-color: #f0f1f2 !important;
  }
`;
